// extracted by mini-css-extract-plugin
module.exports = {"subTitleWrapper":"Page_subTitleWrapper__3WbRi","paragraph":"Page_paragraph__15Neq","noMargin":"Page_noMargin__1h6_h","font":"Page_font__r2D_r","title":"Page_title__3gKIg"};